//TODO: refactor 



var searchParams = new URLSearchParams(window.location.search);
var search = searchParams.get('title');
    $('.step-item-arrow .arrow, .step-one-button .step-item, .step-two-button .step-item, .step-two-button .step-item, .step-three-button .step-item').click(e=>{
      [...document.querySelectorAll('.select-prepay_selected')].forEach(btn=>{
        // btn.classList.remove('select-prepay_selected');
        if(btn.classList.contains('select-prepay_selected')) btn.click();
      })
    })

// Preloader animation for /pages/gift-checkout-page STEP 1 > 2
if (search) {

    function loadData() {
        return new Promise((resolve, reject) => {
            setTimeout(resolve, 2000);
        });
    }

    loadData()
        .then(() => {
            let preloaderEl = document.getElementById('preloader');
            preloaderEl.classList.add('hidden');
            preloaderEl.classList.remove('visible');
        });
} else {
    function loadData() {
        return new Promise((resolve, reject) => {
            setTimeout(resolve, 100);
        });
    }

    loadData()
        .then(() => {
            let preloaderEl = document.getElementById('preloader');
            preloaderEl.classList.add('hidden');
            preloaderEl.classList.remove('visible');
        });
}
// End of preloader animation

jQuery(document).ready(function() {
    // redirect back to custom checkout page
    var currentUrl = window.location.href;

    // if (currentUrl.includes('?')) {
    //     window.location.href = '/pages/checkout-page';
    // };

    //TODO: Remove unused variables
    var productId, variantId, variantPrice, selectedProduct, selectedMonthsQuantity, selectedMonthFrequency, subscriptionId, matchedProduct, matchedVariant, additionalSubscriptionProductId,
        additionalSubscriptionProductQuantity,sellingId;

    var monthlySubscription, monthlyVariantId, biMonthlyVariantId, biMonthlySubscription;

    var width = $(window).width();

    var ProductObj = {
        productTitle: '',
        productVariantTitle: ''
    };

    // GET COLLECTIONS PRODUCTS
    var monthlyProducts = '';
    monthlyProducts = document.monthly_collection_products;

    var threeMonthProducts = '';
    threeMonthProducts = document.three_months_collection_products;

    var sixMonthProducts = '';
    sixMonthProducts = document.six_months_collection_products;

    var twelveMonthProducts = '';
    twelveMonthProducts = document.twelve_months_collection_products;

    var biMonthlyProducts = '';
    biMonthlyProducts = document.bi_monthly_collection_products;

    var biThreeMonthProducts = '';
    biThreeMonthProducts = document.three_bimonths_collection_products;

    var biSixMonthProducts = '';
    biSixMonthProducts = document.six_bimonths_collection_products;

    var biTwelveMonthProducts = '';
    biTwelveMonthProducts = document.twelve_bimonths_collection_products;


    //redirect from our clubs page to checkout-page (get params)
    if (search) {
        $('.checkout-step-one').hide();
        // $('.products-wrapper').find("[data-product-title='" + search + "']").addClass('selected');

        if ($(".checkout-product-item").hasClass("selected")) {
            if (width <= 768) {
                $(".step-one-button .step-title").css('display', 'none');
                $(".step-two-button .step-title").css('display', 'flex');
                $(".step-three-button .step-title").css('display', 'none');
                $(".step-four-button .step-title").css('display', 'none');
            }
            $(".step-button-wrapper.step-two-button").children(':first').addClass("active-btn");
            $(".checkout-step-two").fadeIn(1000);
            $(".step-one-button").addClass("pointer");

            productId = $('.checkout-product-item.selected').attr('data-product-id');

            selectedProduct = products[productId];

            ProductObj.productTitle = selectedProduct.title;

            var html = '';
            selectedProduct.newVariants.forEach(function(variant, pos) {
                html += createClubLevel(variant, pos);
            });
            document.querySelectorAll(".additional-product-wrapper .additional-product").forEach(function(elem) {
                elem.remove();
            });

            var addProduct = '';
            document.addProducts_collection.forEach(function(item) {
                if (item.tags.includes(selectedProduct.title)) {
                    addProduct += createAddProduct(item);
                }
            });

            $('.checkout-step-two .club-level-wrapper').html(html);
            $('.checkout-step-four .additional-product-wrapper').html(addProduct);
            // $('.step-one-button').append('<div class="step-one_selected">' + selectedProduct.title +'</div>');
            $('.cta-button.club-level-select').click(()=>{
              $("#bi-monthly-select, #monthly-select").attr('data-variant-id', variantId);
              $("#bi-monthly-select, #monthly-select").attr('spid', sellingId);
              $("#bi-monthly-select").attr('data-interval-frequency', 2);
              $("#bi-monthly-select").attr('data-subscription-id', 225157);
              $("#bi-monthly-select").attr('data-months-quantity', 2);
              $("#bi-monthly-select").attr('data-renewal-duration', 2);
              $(".monthly-frequency").eq(1).html('Every <span class="bi-monthly-length">2</span> Months');
              $("#monthly-select").attr('data-interval-frequency', 1);
              $("#monthly-select").attr('data-subscription-id', 220626);
              $("#monthly-select").attr('data-months-quantity', 1);
              $("#monthly-select").attr('data-renewal-duration', 1);
              $(".monthly-frequency").eq(0).html('<span class="monthly-length">Every Month</span>');
        	})
        }

    }


    // step one
    $(".checkout-product-item").on('click touchstart', function() {
        if ($(".checkout-product-item").hasClass("selected")) {
            $(".checkout-product-item").removeClass("selected");
        }

        if (width <= 768) {
            $(".step-one-button .step-title").css('display', 'none');
            $(".step-two-button .step-title").css('display', 'flex');
            $(".step-three-button .step-title").css('display', 'none');
            $(".step-four-button .step-title").css('display', 'none');
        }

        $('.step-one_selected').remove();
        $('.step-one-button').append('<div class="step-one_selected">' + $(this).attr('data-product-title') + '</div>');
        $('.step-two-button').children('.step-item').addClass('active-btn');

        $(this).addClass("selected");
        $(".checkout-step-one").fadeOut(100);
        $(".checkout-step-four").fadeOut(100);
        $(".step-button-wrapper.step-two-button").children(':first').addClass("active-btn");
        $(".checkout-step-two").fadeIn(1000);
        $(".step-one-button").addClass("pointer");

        productId = $(this).attr('data-product-id');

        selectedProduct = products[productId];
        console.log('selectedProduct', selectedProduct);

        ProductObj.productTitle = selectedProduct.title;

        var html = '';
        selectedProduct.newVariants.forEach(function(variant, pos) {
            html += createClubLevel(variant, pos);
        });
        document.querySelectorAll(".additional-product-wrapper .additional-product").forEach(function(elem) {
            elem.remove();
        });
        var addProduct = '';
        document.addProducts_collection.forEach(function(item) {
            if (item.tags.includes(selectedProduct.title)) {
                addProduct += createAddProduct(item);
            }
        });

        $('.checkout-step-two .club-level-wrapper').html(html);

        var showAdditional = document.show_additional_products;

        //Show additional products if in show-addtional-products collection
        for (var pos in showAdditional) {
            if (selectedProduct.id == showAdditional[pos].id) {
                $('.step-four-custom').hide();
                $('.checkout-step-four .additional-product-wrapper').html(addProduct);
                break
            } else {
                $('.step-four-custom').show();
            }
        }

        //Only show additional products on specific products
        // var comingSoonMessage = '<div class="coming-soon"><h1>New Products Coming Soon</h1></div>';

        // if(selectedProduct.id == 4182598549594 || selectedProduct.id == 4182602776666) {
        //     $('.checkout-step-four .additional-product-wrapper').html(comingSoonMessage);
        // } else {
        //     $('.checkout-step-four .additional-product-wrapper').html(addProduct);
        // }

        $('.arrow-disable').hide();
        $('.arrow').show();
        $('.arrow').attr('data-prev', 1);

        $(window).scrollTop(0);
  
  		$('.cta-button.club-level-select').click((e)=>{
          if(e.target===document.querySelector('#monthly-select')||e.target===document.querySelector('#bi-monthly-select')) return;
          console.log('this:', e.target);
          $("#bi-monthly-select, #monthly-select").attr('data-variant-id', variantId);
          $("#bi-monthly-select, #monthly-select").attr('spid', sellingId);
          $("#bi-monthly-select").attr('data-interval-frequency', 2);
          $("#bi-monthly-select").attr('data-subscription-id', 225157);
          $("#bi-monthly-select").attr('data-months-quantity', 2);
          $("#bi-monthly-select").attr('data-renewal-duration', 2);
          $(".monthly-frequency").eq(1).html('Every <span class="bi-monthly-length">2</span> Months');
          $("#monthly-select").attr('data-interval-frequency', 1);
          $("#monthly-select").attr('data-subscription-id', 220626);
          $("#monthly-select").attr('data-months-quantity', 1);
          $("#monthly-select").attr('data-renewal-duration', 1);
          $(".monthly-frequency").eq(0).html('<span class="monthly-length">Every Month</span>');
        })
    });

    //Additional product add to cart
    $(document).on('click touchstart', '.additional-product .cta-button.add-to-cart', function() {
        jQuery.post("/cart/add.js", {
            id: $(this).closest('.additional-product').data('id'),
            quantity: 1
        }).then(function(response) {
          $.ajax({
            url: '/cart.js',
            dataType: 'json',
            cache: false,
            success(cart) {
              setTimeout(function () {
                refreshCart(cart);
                if ($('body').hasClass('fancybox-active')) {
                  $.fancybox.close();
                }

                if ($('#header').is(':visible')) {
                  $('#header .cart-container').addClass('active_link');
                } else if ($('.sticky_nav--stick').length) {
                  $('.sticky_nav .cart-container').addClass('active_link');
                } else {
                  $('.top-bar .cart-container').addClass('active_link');
                }

                // block scrolling on mobile
                if (window.Shopify.media_queries.medium.matches) {
                  const $cartContainer = $(this).parent();
                  if ($cartContainer.hasClass('active_link')) {
                    $('body').addClass('blocked-scroll');
                  } else {
                    $('body').addClass('blocked-scroll');
                  }
                }
              }, 500);
            },
          });
        });
    });

    function refreshCart(cart) {
      $('.cart_count').empty();
      const $cartBtn = $('.cart_count');
      const value = $cartBtn.text() || '0';
      let cartItemsHTML = "";
      let cartDiscountsHTML = "";
      let cartActionHTML = "";
      let cartSavingsHTML = "";
      const $cartForm = $('[data-cart-form]');
      let productHasSale = false;
      let productCompareAtPrice = 0;
      let productFinalPrice = 0;
  
      $cartForm.data('total-discount', cart.total_discount);
  
      $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));
  
      if (cart.item_count === 0) {
        $('.js-empty-cart__message').removeClass('hidden');
        $cartForm.addClass('hidden');
      } else {
        $('.js-empty-cart__message').addClass('hidden');
        $cartForm.removeClass('hidden');
  
        let totalSaving = 0; // adding counter variables for total cart savings
        let saving = 0;
  
        $.each(cart.items, (index, item) => {
          const itemDiscounts = item.discounts;
          let discountMessage = '';
  
          for (let i = 0; i < itemDiscounts.length; i++) {
            const { title } = itemDiscounts[i];
            discountMessage = `<p class="notification-discount meta">${title}</p>`;
          }
          const lineID = index + 1;
  
          cartItemsHTML += `<li class="mini-cart__item" data-cart-item data-line-id="${lineID}" data-variant-id="${item.id}">`
            + `<a href="${item.url}">`;
          if (item.image) {
            cartItemsHTML += `${'<div class="cart_image">'
                + '<img src="'}${item.image.replace(/(\.[^.]*)$/, '_compact$1').replace('http:', '')}" alt="${htmlEncode(item.title)}" />`
              + '</div></a>';
          }
  
          cartItemsHTML += `<div class="mini-cart__item-content"><div class="mini-cart__item-title"><a href="${item.url}">${item.title}</a>`;
  
          if (item.selling_plan_allocation) {
            cartItemsHTML += `<div class="meta">${item.selling_plan_allocation.selling_plan.name}</div>`;
          }
  
          if (item.properties) {
            $.each(item.properties, (title, value) => {
              if (value) {
                cartItemsHTML += `<div class="line-item">${title}: ${value} </div>`;
              }
            });
          }
  
          cartItemsHTML += '</div><div class="mini-cart__item-price">';
  
          $.ajax({
            dataType: 'json',
            async: false,
            cache: false,
            url: `/products/${item.handle}.js`,
            success(data) {
              let productData = data;
              // If item has more than one variant, need to make sure we are pulling data from the correct variant
              if (productData.variants) {
                const itemVariants = productData.variants;
                if (itemVariants.length > 1) {
                  for (let v = 0; v < itemVariants.length; v++) {
                    if (itemVariants[v].id === item.id) {
                      productData = itemVariants[v];
                    }
                  }
                }
              }
  
              // If compare at price exists then item is on sale
              if (productData.compare_at_price) {
                if (productData.compare_at_price > productData.price) {
                  productHasSale = true;
                  productCompareAtPrice = productData.compare_at_price;
                  productFinalPrice = productData.price;
                }
              } else {
                // Check required for non-sale items
                productHasSale = false;
              }
            },
          });
  
          if (productHasSale === true) {
            // puts the slash through the old item price
            const itemPrice = `${window.Shopify.formatMoney(productFinalPrice, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(productCompareAtPrice, $('body').data('money-format'))}</span>`;
            cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;
  
            // Total savings
            saving = (productCompareAtPrice - productFinalPrice) * item.quantity;
            totalSaving = saving + totalSaving;
          } else if (item.price > item.final_price) {
            // puts the slash through the old item price
            const itemPrice = `${window.Shopify.formatMoney(item.final_price, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(item.price, $('body').data('money-format'))}</span>`;
            cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;
          } else {
            const itemPrice = window.Shopify.formatMoney(item.price, $('body').data('money-format'));
            if (item.price > 0) {
              cartItemsHTML += `<span class="money">${itemPrice}</span></strong>`;
            } else {
              cartItemsHTML += `<span>${window.Shopify.translation.cart_free_text}</span></strong>`;
            }
          }
  
          cartItemsHTML += '</div>';
  
          // Unit price
  
          if (item.unit_price_measurement && item.price > 0) {
            let unitPriceMeasurementReferenceValue = '';
  
            if (item.unit_price_measurement.reference_value !== 1) {
              unitPriceMeasurementReferenceValue = item.unit_price_measurement.reference_value;
            }
  
            cartItemsHTML += `<p class="mini-cart__unit-price">${item.unit_price_measurement.quantity_value}${item.unit_price_measurement.quantity_unit} | ${Shopify.formatMoney(item.unit_price, $('body').data('money-format'))} / ${unitPriceMeasurementReferenceValue}${item.unit_price_measurement.reference_unit}</p>`;
          }
  
          if (item.price > item.final_price) {
            cartItemsHTML += discountMessage;
          }
  
          cartItemsHTML += '<div class="product-quantity-box">';
          cartItemsHTML += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>';
          cartItemsHTML += `<input type="number" min="0" class="quantity" name="updates[]" id="updates_${item.id}" value="${item.quantity}" data-cart-quantity-input="mini-cart" />`;
          cartItemsHTML += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
          cartItemsHTML += '</div></div></div>';
          cartItemsHTML += `<a href="/cart/change?line=${lineID}&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="${lineID}" data-remove-item="mini-cart"><span class="remove-icon"></span></a>`;
        });
  
        const cartDiscounts = cart.cart_level_discount_applications;
  
        for (let i = 0; i < cartDiscounts.length; i++) {
          const amount = window.Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
          const { title } = cartDiscounts[i];
  
          cartDiscountsHTML += `<span class="cart_discounts--title">${title}</span>`;
          cartDiscountsHTML += '<span class="cart_discounts--price">';
          cartDiscountsHTML += `-<span class="money">${amount}</span></span>`;
        }
  
        cartActionHTML += `<span class="right"><span class="money">${window.Shopify.formatMoney(cart.total_price, $('body').data('money-format'))}</span></span> <span>${Shopify.translation.cart_subtotal_text}</span>`;
        totalSaving += cart.total_discount;
        if (window.Shopify.theme_settings.display_savings && totalSaving > 0) {
          cartSavingsHTML = `<span class="right"><span class="money">${window.Shopify.formatMoney(totalSaving, $('body').data('money-format'))}</span></span>`
              + `<span>${window.Shopify.translation.cart_savings_text}</span>`;
        } else {
          cartSavingsHTML = '';
        }
      }
  
      $('.js-cart_items').html(cartItemsHTML);
      $('.js-cart_discounts').html(cartDiscountsHTML);
      $('.js-cart_subtotal').html(cartActionHTML);
      $('.js-cart_savings').html(cartSavingsHTML);
  
      // Converting the currencies
      if (window.Currency.show_multiple_currencies) {
        window.currencyConverter.convertCurrencies();
      }
    }
    
    function createAddProduct(item) {
        return '<div class="additional-product" data-id="' + item.variants[0].id + '"> \
                    <img src="' + item.featured_image + '">' + '</img>' +
            '<h3>' + item.title + '</h3>' +
            '<p><span class="price">' + Shopify.formatMoney(item.price, $('body').data('money-format')) + '</span></p>' +
            item.description +
            '<div class="cta-button-wrapper">' +
            '<div class="cta-button add-to-cart"><a>ADD TO CART</a></div></div>' +
            '</div>';
    }

    // step two
    $(".step-one-button .step-item").on('click touchstart', function() {
        stepOne();
        $(window).scrollTop(0);
    });

    function stepOne() {
        $('.step-one_selected').remove();
        $(".checkout-product-item").removeClass("selected");

        $(".step-button-wrapper.step-two-button").children('.step-item').removeClass("active-btn");
        $(".step-button-wrapper.step-three-button").children('.step-item').removeClass("active-btn");;
        $(".step-button-wrapper.step-four-button").children('.step-item').removeClass("active-btn");;
        $(".checkout-step-two").fadeOut(100);
        $(".checkout-step-three").fadeOut(100);
        $(".checkout-step-four").fadeOut(100);
        $(".checkout-step-one").fadeIn(1000);
        $(".step-one-button").removeClass("pointer");
        $(".step-two-button").removeClass("pointer");
        $(".step-three-button").removeClass("pointer");

        if (width <= 768) {
            $(".step-one-button .step-title").css('display', 'flex');
            $(".step-two-button .step-title").css('display', 'none');
            $(".step-three-button .step-title").css('display', 'none');
            $(".step-four-button .step-title").css('display', 'none');
        }

        $('.arrow').hide();
        $('.arrow-disable').show();
    }

    // step arrows
    $('.arrow').on('click touchstart', function() {
        var prevStep = $(this).attr('data-prev');

        if (prevStep == 1) {
            stepOne();
        } else if (prevStep == 2) {
            stepTwo();
        } else if (prevStep == 3) {
            stepThree();
        };
    })

    function createClubLevel(variant, pos) {
      console.log(variant, pos)
        var price_no_decimals = Math.trunc(variant.price / 100);
        var glass = $('.icon-glass').attr('src');
        var arrow = $('.icon-arrow').attr('src');

        var iconBar = '<div><img class="glass-icon" src="' + glass + '"></div>';

        if (pos == 1) {
            iconBar = '<div><img class="glass-icon" src="' + glass + '"><img class="arrow-icon" src="' + arrow + '"><img class="glass-icon-1" src="' + glass + '"></div>';
        } else if (pos == 2) {
            iconBar = '<div><img class="glass-icon" src="' + glass + '"><img class="arrow-icon" src="' + arrow + '"><img class="glass-icon-1" src="' + glass + '"><img class="arrow-icon-1" src="' + arrow + '"><img class="glass-icon-2" src="' + glass + '"></div>';
        }

        var club_level = '<div class="club-level-item club-level-' + pos + '"> \
            <div class="club-level-title"> \
                <div class="club-title-box"><h3 class="club-title-text club-title-' + pos + '">' + variant.title + '</h3></div> \
            </div>' +
            '<div class="club_level-container">' +
            '<div class="club-level-price"> \
                    <h4>$' + price_no_decimals + '</h4> \
                    <span class="club-level-price-unit">per shipment</span> \
                </div>' +
            '<div class="club-level-desc">' +
            '<div>' + (variant.desc ? variant.desc : "") + '</div>' +
            '<div class="club-level-icon club-level-icon_' + pos + '">\
                    ' + iconBar + '</div> \
                </div> \
            </div> \
            <div class="product-content"> \
                <div class="cta-button club-level-select"> \
                    <a class="club-level-item_btn" data-spid = "'+variant.selling_plan_allocations[0].selling_plan_id+'" data-product-title="' + variant.title + '" data-product-variant-id="' + variant.id + '" data-product-variant-title="' + variant.title + '" data-product-variant-price="' + variant.price + '">SELECT</a> \
                </div> \
            </div> \
        </div>'

        return club_level;
    }

    //TODO: Refactor
    function searchCollection(collection, productTitle, variantTitle) {
        var variantData = [];

        if (productTitle == 'Rosé') {
            productTitle = 'rose';
        }

        for (x in collection) {
            console.log(1, productTitle.toLowerCase(), collection[x].handle);
            if ((collection[x].handle).includes(productTitle.toLowerCase())) {
                console.log(2);
                for (ele in collection[x].variants) {
                    console.log(3);
                    var test = collection[x].variants;
                    if (test[ele].title == variantTitle) {
                        variantData.push(test[ele])
                        // break
                    }
                }
            }
        }

        return variantData;
    }

    $(document).on('click touchstart', '.club-level-item_btn', function() {
        if ($(".club-level-item").hasClass("selected")) {
            $(".club-level-item").removeClass("selected");
        }

        variantId = $(this).attr('data-product-variant-id');
       sellingId = $(this).attr('data-spid');
      // alert(sellingId+"<<<<<S<<>>>V>>>"+ variantId)

        // console.log('productVarinatId', variantId);
        ProductObj.productVariantTitle = $(this).attr('data-product-variant-title');

        // console.log(ProductObj.productVariantTitle);
        variantPrice = $(this).attr('data-product-variant-price');

        $('.monthly-price, .bi-monthly-price').empty().append(convertPrice(variantPrice));
        $('.monthly-price, .bi-monthly-price').attr('data-monthly-price', convertPrice(variantPrice));

        //store recharge data on select btn
        $('.select-month-item_btn').each(function() {
            // $(this).append(123)
            if ($(this).attr('data-months-quantity') == 1) {
                $(this).attr('data-variant-id', variantId);
              $(this).attr('spid', sellingId);
                $(this).attr('data-interval-frequency', 1);
                $(this).attr('data-subscription-id', 220626);

                var monthlyData =  searchCollection(monthlyProducts, ProductObj.productTitle, ProductObj.productVariantTitle)
              console.log('monthly data:', monthlyData)

              for(var i = 0; i < monthlyData.length; i++) {
                    var ele = monthlyData[i];
                    if(ele.name.toLowerCase().includes('gift')){
                    $(this).attr('data-gift-variant-id', ele.id);
                    }
                }


                monthlySubscription = 220626;
                monthlyVariantId = variantId;

            } else if ($(this).attr('data-months-quantity') == 2) {

                var biMonthlyData = searchCollection(biMonthlyProducts, ProductObj.productTitle, ProductObj.productVariantTitle);
                console.log(23, ProductObj.productTitle, ProductObj.productVariantTitle);

                for(var i = 0; i < biMonthlyData.length; i++) {
                    var ele = biMonthlyData[i];
                    if(ele.name.toLowerCase().includes('gift')){
                        $(this).attr('data-gift-variant-id', ele.id);
                    }else{
                        $(this).attr('data-variant-id', ele.id);
                      $(this).attr('spid', ele.selling_plan_allocations[0].selling_plan_id);
                    }
                }
                $(this).attr('data-interval-frequency', 2);
                $(this).attr('data-subscription-id', 225157);

                biMonthlySubscription = 225157;
                biMonthlyVariantId = variantId;
            }
        });

        // $(this).addClass("selected");

        $('.step-two-button').append('<div class="step-one_selected">' + $(this).attr('data-product-variant-title') + '</div>');

        $(".checkout-step-two").fadeOut(100);
        $(".checkout-step-four").fadeOut(100);
        $(".step-button-wrapper.step-three-button").children('.step-item').addClass("active-btn");;
        $(".checkout-step-three").fadeIn(1000);
        $(".step-two-button").addClass("pointer");


        if (width <= 768) {
            $(".step-one-button .step-title").css('display', 'none');
            $(".step-two-button .step-title").css('display', 'none');
            $(".step-three-button .step-title").css('display', 'flex');
            $(".step-four-button .step-title").css('display', 'none');
        }

        $('.step-one-button, .step-one-line').addClass('step-hide');
        $('.step-four-button, .step-line-adjust').addClass('step-show-mobile');
        $('.step-title-desktop').addClass('step-title-hide');

        //Uncheck gift checkbox on load
        // $('.gift-check').each(function() {
        //     $(this).removeAttr('checked');
        // });

        $('.arrow').attr('data-prev', 2);

        $('.select-prepay_option').each(function() {
            $(this).removeClass('select-prepay_selected');
        })

        //TODO: turn into function
        $('.gift-check').each(function() {
            console.log('checked', $(this));
            $(this).attr('checked', false);
        });

        $('.gift-textarea').each(function() {
            $(this).hide();
            $(this).children().val('');

            $(this).parents('.select-month-item').removeClass('select-month_max_height');
        });

    });

    // step three
    $(".step-two-button .step-item").on('click touchstart', function() {
        stepTwo();
        $(window).scrollTop(0);
    });

    function stepTwo() {
        if ($(".step-three-button").children('.step-item').hasClass("active-btn")) {
            $(".step-button-wrapper.step-three-button").children('.step-item').removeClass("active-btn");;
            $(".step-button-wrapper.step-four-button").children('.step-item').removeClass("active-btn");;
            $(".checkout-step-three").fadeOut(100);
            $(".checkout-step-four").fadeOut(100);
            $(".checkout-step-two").fadeIn(1000);
            $(".step-two-button").removeClass("pointer");
            $(".step-three-button").removeClass("pointer");
        }

        if (width <= 768) {
            $(".step-one-button .step-title").css('display', 'none');
            $(".step-two-button .step-title").css('display', 'flex');
            $(".step-three-button .step-title").css('display', 'none');
            $(".step-four-button .step-title").css('display', 'none');
        }

        // Clear previously selected products on steps
        $(".step-button-wrapper.step-two-button").children('.step-one_selected').remove();
        $(".step-button-wrapper.step-three-button").children('.step-one_selected').remove();

        $('.step-one-button, .step-one-line').removeClass('step-hide');
        $('.step-four-button, .step-line-adjust').removeClass('step-show-mobile');
        $('.step-title-desktop').removeClass('step-title-hide');

        $('.arrow').attr('data-prev', 1);
    }

    // $( ".select-month-item_btn" ).click(function() {
    //     //Bottle Monthly Bi-monthly
    //     selectedMonthsQuantity = $(this).attr('data-months-quantity');
    //     console.log('Selected months quantity', selectedMonthsQuantity);

    //     var selectedFrequencyText = "Monthly";

    //     if (selectedMonthsQuantity == 1) {
    //         subscriptionId = 220626;
    //         selectedMonthFrequency = 1;
    //     } else if (selectedMonthsQuantity == 2) {
    //         subscriptionId = 225157;
    //         selectedMonthFrequency = 2;
    //         //ProductObj.productTitle
    //         //ProductObj.productVariantTitle
    //         selectedFrequencyText = "Bi-monthly";
    //     }

    //     $(this).addClass("selected");

    //     if ($(".select-month-item").hasClass("selected")) {
    //         $(".select-month-item").removeClass("selected");
    //     }
    //     if ($(".select-bottle-item").hasClass("selected")) {
    //         $(".select-bottle-item").removeClass("selected");
    //     }

    //     $('.step-three-button').append('<div class="step-one_selected">' + selectedFrequencyText +'</div>');

    //     $(this).addClass("selected");

    //     // Hide step one button on mobile
    //     $('.step-one-button, .step-one-line').addClass('step-hide');
    //     $('.step-four-button, .step-line-adjust').addClass('step-show-mobile');
    //     $('.step-title-desktop').addClass('step-title-hide');

    //     stepFour();
    // });


    $('.select-month-item_btn').on('click touchstart', function() {
        //Bottle Monthly Bi-monthly
        var rechargeId = $(this).attr('data-variant-id');
        var renewalDuration = $(this).attr('data-renewal-duration')
        var rechargeQty = renewalDuration / $(this).attr('data-months-quantity');
        var rechargeFreq = $(this).attr('data-interval-frequency');
        var rechargeUnit = $(this).attr('data-unit');
        var rechargeSubId = $(this).attr('data-subscription-id');
        var rechargeGift = $(this).attr('data-gift-message');
        var giftCheckbox = $(this).closest('.select-month-item').find('.gift-checkbox input.gift-check');
        var isGiftChecked = false;
      var spid = $(this).attr('spid');
      //  if(spid == null) {
      //   $(this).closest('.select-month-item').find('.select-prepay_option').eq(0).click();
      //   spid = $(this).attr('spid');
      // }
        if(giftCheckbox.prop("checked") == true){
            isGiftChecked = true;
            rechargeId = $(this).attr('data-gift-variant-id')
        }
        else if(giftCheckbox.prop("checked") == false){
            isGiftChecked = false;
        }
        selectedMonthsQuantity = $(this).attr('data-months-quantity');

        var selectedFrequencyText = "Monthly";

        if (rechargeFreq == 2) {
            selectedFrequencyText = "Bi-Monthly";
        }

        //  if (selectedMonthsQuantity == 1) {
        //      subscriptionId = 220626;
        //      selectedMonthFrequency = 1;

        //  } else if (selectedMonthsQuantity == 2) {
        //      subscriptionId = 225157;
        //      selectedMonthFrequency = 2;

        //      //ProductObj.productTitle
        //      //ProductObj.productVariantTitle
        //      selectedFrequencyText = "Bi-monthly";
        //  }

        //  $(this).addClass("selected");

        if ($(".select-month-item").hasClass("selected")) {
            $(".select-month-item").removeClass("selected");
        }
        if ($(".select-bottle-item").hasClass("selected")) {
            $(".select-bottle-item").removeClass("selected");
        }

        $('.step-three-button').append('<div class="step-one_selected">' + selectedFrequencyText + '</div>');

        $('.select-month-item').addClass("selected");

        // Hide step one button on mobile
        $('.step-one-button, .step-one-line').addClass('step-hide');
        $('.step-four-button, .step-line-adjust').addClass('step-show-mobile');
        $('.step-title-desktop').addClass('step-title-hide');

        // console.log(rechargeId, renewalDuration, rechargeQty, rechargeUnit, rechargeSubId, rechargeGift)
        // return
        // addItemToCart(variant_id, quantity, charge_interval_frequency, shipping_interval_unit_type, subscription_id, gift_message)
        addItemToCart(rechargeId, selectedMonthsQuantity, renewalDuration, rechargeUnit, rechargeSubId, rechargeGift, isGiftChecked, spid);

        $('.arrow').attr('data-prev', 3);

        $('.gift-check').each(function() {
            $(this).attr('checked', false);
        })

    });

    //Monthly prepaid
    $('.select-prepay_monthly').on('click', function() {
        selectedMonthFrequency = $(this).attr('data-shipping-frequency') || 1;
        selectBottleNumber = $(this).attr('data-bottle-number');
        var $monthly_price = $('.monthly-price');
        var $monthly_saving = $('.monthly-saving');
        var $monthly_length = $('.monthly-length');

        var $monthly_select = $('#monthly-select');

        var $selected = 'select-prepay_selected';

        var original_price = $monthly_price.attr('data-monthly-price');
        // var original_month = ($(this).closest('.select-month-item')).attr('data-months-quantity');

        var original_month = 'Every Month';
        var prepaid_variant_price, saving;

        if ($(this).hasClass($selected)) {
            $(this).removeClass($selected);
        } else {
            $('.select-prepay .select-prepay_monthly').removeClass($selected);
            $(this).addClass($selected);
        }
      var spId = null;

        //change price and frequency
        if (selectBottleNumber == 3) {
            matchedProduct = findMatchedProduct(ProductObj.productTitle, threeMonthProducts);
            matchedVariant = findMatchedVariant(ProductObj.productVariantTitle, matchedProduct.variants);
            console.log('matchedVariant monthly ', matchedVariant)
            prepaid_variant_price = convertPrice(matchedVariant.variant_price);
            saving = ((original_price * selectBottleNumber) - prepaid_variant_price).toFixed(2);
spId = matchedVariant.selling_plan_id;
             var threeMonth =  searchCollection(threeMonthProducts, ProductObj.productTitle, ProductObj.productVariantTitle)
              
              for(var i = 0; i < threeMonth.length; i++) {
                    var product = threeMonth[i];
                    if(product.name.toLowerCase().includes('gift')){
                    $monthly_select.attr('data-gift-variant-id', product.id);
                    }
                }

            if ($(this).hasClass($selected)) {
                $monthly_price.empty().append(prepaid_variant_price);
                $monthly_saving.empty().append(saving);
                $monthly_length.empty().append('Every ' + 3 + ' Months');
                 console.log(monthlyVariantId.variant_id,'monthlyVariantIdvariant>>>>>');
                $monthly_select.attr('data-variant-id', matchedVariant.variant_id);
                $monthly_select.attr('data-subscription-id', 225162);
                $monthly_select.attr('data-interval-frequency', selectedMonthFrequency);
                            

            } else {
                // reset to monthly rate
                $monthly_price.empty().append(original_price);
                $monthly_length.empty().append(original_month);
                $monthly_saving.empty().append(0);
                console.log(monthlyVariantId,'monthlyVariantId>>>>>');
                $monthly_select.attr('data-variant-id', monthlyVariantId);
                $monthly_select.attr('data-subscription-id', monthlySubscription);
                $monthly_select.attr('data-interval-frequency', 1);
                selectBottleNumber = 1;
            }

        } else if (selectBottleNumber == 6) {
            matchedProduct = findMatchedProduct(ProductObj.productTitle, sixMonthProducts);
            matchedVariant = findMatchedVariant(ProductObj.productVariantTitle, matchedProduct.variants);
            prepaid_variant_price = convertPrice(matchedVariant.variant_price);
            saving = ((original_price * selectBottleNumber) - prepaid_variant_price).toFixed(2);
spId = matchedVariant.selling_plan_id;
              var sixMonth =  searchCollection(sixMonthProducts, ProductObj.productTitle, ProductObj.productVariantTitle)

              for(var i = 0; i < sixMonth.length; i++) {
                    var product = sixMonth[i];
                    if(product.name.toLowerCase().toLowerCase().includes('gift')){
                    $monthly_select.attr('data-gift-variant-id', product.id);
                    }
                }

            if ($(this).hasClass($selected)) {
                $monthly_price.empty().append(prepaid_variant_price);
                $monthly_saving.empty().append(saving);
                // $monthly_length.empty().append(selectedMonthFrequency);
                $monthly_length.empty().append('Every ' + 6 + ' Months');
               console.log(matchedVariant.variant_id,'monthlyVariantIdvarianttt>>>>>');

                $monthly_select.attr('data-variant-id', matchedVariant.variant_id);
                $monthly_select.attr('data-subscription-id', 225187);
                $monthly_select.attr('data-interval-frequency', selectedMonthFrequency);

            } else {
                $monthly_price.empty().append(original_price);
                $monthly_length.empty().append(original_month);
                $monthly_saving.empty().append(0);
              console.log(monthlyVariantId,'monthlyVarianttt>>>>>');
                $monthly_select.attr('data-variant-id', monthlyVariantId);
                $monthly_select.attr('data-subscription-id', monthlySubscription);
                $monthly_select.attr('data-interval-frequency', 1);
                selectBottleNumber = 1;
            }

        } else if (selectBottleNumber == 12) {
            matchedProduct = findMatchedProduct(ProductObj.productTitle, twelveMonthProducts);
            matchedVariant = findMatchedVariant(ProductObj.productVariantTitle, matchedProduct.variants);
            prepaid_variant_price = convertPrice(matchedVariant.variant_price);
            saving = ((original_price * selectBottleNumber) - prepaid_variant_price).toFixed(2);
spId = matchedVariant.selling_plan_id;
              var twelveMonth =  searchCollection(twelveMonthProducts, ProductObj.productTitle, ProductObj.productVariantTitle)

              
              for(var i = 0; i < twelveMonth.length; i++) {
                    var product = twelveMonth[i];
                    if(product.name.toLowerCase().includes('gift')){
                    $monthly_select.attr('data-gift-variant-id', product.id);
                    }
                }
          
            if ($(this).hasClass($selected)) {
                $monthly_price.empty().append(prepaid_variant_price);
                $monthly_saving.empty().append(saving);
                // $monthly_length.empty().append(selectedMonthFrequency);
                $monthly_length.empty().append('Every ' + 12 + ' Months');

                console.log(matchedVariant.variant_id,'Varianttt>>>>>');
                $monthly_select.attr('data-variant-id', matchedVariant.variant_id);
                $monthly_select.attr('data-subscription-id', 225192);
                $monthly_select.attr('data-interval-frequency', selectedMonthFrequency);

            } else {
                $monthly_price.empty().append(original_price);
                $monthly_length.empty().append(original_month);
                $monthly_saving.empty().append(0);

                $monthly_select.attr('data-variant-id', monthlyVariantId);
                $monthly_select.attr('data-subscription-id', monthlySubscription);
                $monthly_select.attr('data-interval-frequency', 1);
                selectBottleNumber = 1;
            }
        }
      console.log(spId ,'<<<<<<<<abhinada')
        $('#monthly-select').attr('data-renewal-duration', selectedMonthFrequency * selectBottleNumber).attr('spid',spId);;
    });

    //Prepaid Bi-monthly
    $('.select-prepay_bi-monthly').on('click', function() {
        selectedMonthFrequency = $(this).attr('data-shipping-frequency') || 2;
        selectBottleNumber = $(this).attr('data-bottle-number');

        var $biMonthlyPrice = $('.bi-monthly-price');
        var $biMonthlySaving = $('.bi-monthly-saving');
        var $biMonthlyLength = $('.bi-monthly-length');

        var $selected = 'select-prepay_selected';

        var original_price = $biMonthlyPrice.attr('data-monthly-price');
        var original_month = ($(this).closest('.select-month-item')).attr('data-months-quantity');
        var prepaid_variant_price, saving;

        if ($(this).hasClass($selected)) {
            $(this).removeClass($selected);
        } else {
            $('.select-prepay .select-prepay_bi-monthly').removeClass($selected);
            $(this).addClass($selected);
        }

        var gift_checkbox = $(this).closest('.select-month-item').find('.gift-checkbox input.gift-check');
        //change price and frequency
      var spId = null;
        if (selectBottleNumber == 3) {
            matchedProduct = findMatchedProduct(ProductObj.productTitle, threeMonthProducts);
            matchedVariant = findMatchedVariant(ProductObj.productVariantTitle, matchedProduct.variants);

            var biThreeMonth = searchCollection(biThreeMonthProducts, ProductObj.productTitle, ProductObj.productVariantTitle);
            prepaid_variant_price = convertPrice(biThreeMonth[0].price);
            saving = ((original_price * selectBottleNumber) - prepaid_variant_price).toFixed(2);
spId = matchedVariant.selling_plan_id;
            if ($(this).hasClass($selected)) {
                $biMonthlyPrice.empty().append(prepaid_variant_price);
                $biMonthlySaving.empty().append(saving);
                $biMonthlyLength.empty().append(6);
              //console.log("test",matchedVariant)
  setTimeout(function(){

               $('#bi-monthly-select').attr('data-variant-id', matchedVariant.variant_id);

                }, 100);
                // $('#bi-monthly-select').attr('data-variant-id', matchedVariant.variant_id);
                for(var i = 0; i < biThreeMonth.length; i++) {
                    var ele = biThreeMonth[i];
                    if(ele.name.toLowerCase().includes('gift')){
                        $('#bi-monthly-select').attr('data-gift-variant-id', ele.id);
                    }else{
                        $('#bi-monthly-select').attr('data-variant-id', ele.id);
                    }
                }
                
                $('#bi-monthly-select').attr('data-subscription-id', 286025);
                $('#bi-monthly-select').attr('data-interval-frequency', selectedMonthFrequency);


            } else {
                $biMonthlyPrice.empty().append(original_price);
                $biMonthlyLength.empty().append(original_month);
                $biMonthlySaving.empty().append(0);

                $('#bi-monthly-select').attr('data-variant-id', biMonthlyVariantId);
                $('#bi-monthly-select').attr('data-subscription-id', biMonthlySubscription);
                $('#bi-monthly-select').attr('data-interval-frequency', 2);
                selectBottleNumber = 1;
            }

        } else if (selectBottleNumber == 6) {
            matchedProduct = findMatchedProduct(ProductObj.productTitle, sixMonthProducts);
            matchedVariant = findMatchedVariant(ProductObj.productVariantTitle, matchedProduct.variants);

            var biSixMonth = searchCollection(biSixMonthProducts, ProductObj.productTitle, ProductObj.productVariantTitle);
            prepaid_variant_price = convertPrice(biSixMonth[0].price);
            saving = ((original_price * selectBottleNumber) - prepaid_variant_price).toFixed(2);
spId = matchedVariant.selling_plan_id;
            if ($(this).hasClass($selected)) {
                $biMonthlyPrice.empty().append(prepaid_variant_price);
                $biMonthlySaving.empty().append(saving);
                $biMonthlyLength.empty().append(12);
               setTimeout(function(){

               $('#bi-monthly-select').attr('data-variant-id', matchedVariant.variant_id);

                }, 100);

                for(var i = 0; i < biSixMonth.length; i++) {
                    var ele = biSixMonth[i];
                    if(ele.name.toLowerCase().includes('gift')){
                        $('#bi-monthly-select').attr('data-gift-variant-id', ele.id);
                    }else{
                        $('#bi-monthly-select').attr('data-variant-id', ele.id);
                    }
                }
                $('#bi-monthly-select').attr('data-subscription-id', 225187);
                $('#bi-monthly-select').attr('data-interval-frequency', selectedMonthFrequency);

            } else {
                $biMonthlyPrice.empty().append(original_price);
                $biMonthlyLength.empty().append(original_month);
                $biMonthlySaving.empty().append(0);

                $('#bi-monthly-select').attr('data-variant-id', biMonthlyVariantId);
                $('#bi-monthly-select').attr('data-subscription-id', biMonthlySubscription);
                $('#bi-monthly-select').attr('data-interval-frequency', 2);
                selectBottleNumber = 1;
            }

        } else if (selectBottleNumber == 12) {
            matchedProduct = findMatchedProduct(ProductObj.productTitle, twelveMonthProducts);
            matchedVariant = findMatchedVariant(ProductObj.productVariantTitle, matchedProduct.variants);

            var biTwelveMonth = searchCollection(biTwelveMonthProducts, ProductObj.productTitle, ProductObj.productVariantTitle);
            prepaid_variant_price = convertPrice(biTwelveMonth[0].price);
            saving = ((original_price * selectBottleNumber) - prepaid_variant_price).toFixed(2);
spId = matchedVariant.selling_plan_id;
            if ($(this).hasClass($selected)) {
                $biMonthlyPrice.empty().append(prepaid_variant_price);
                $biMonthlySaving.empty().append(saving);
                $biMonthlyLength.empty().append(24);
                 setTimeout(function(){

               $('#bi-monthly-select').attr('data-variant-id', matchedVariant.variant_id);

                }, 100);

                for(var i = 0; i < biTwelveMonth.length; i++) {
                    var ele = biTwelveMonth[i];
                    if(ele.name.toLowerCase().includes('gift')){
                        $('#bi-monthly-select').attr('data-gift-variant-id', ele.id);
                    }else{
                        $('#bi-monthly-select').attr('data-variant-id', ele.id);
                    }
                }
                $('#bi-monthly-select').attr('data-subscription-id', 225192);
                $('#bi-monthly-select').attr('data-interval-frequency', selectedMonthFrequency);

            } else {
                $biMonthlyPrice.empty().append(original_price);
                $biMonthlyLength.empty().append(original_month);
                $biMonthlySaving.empty().append(0);

                $('#bi-monthly-select').attr('data-variant-id', biMonthlyVariantId);
                $('#bi-monthly-select').attr('data-subscription-id', biMonthlySubscription);
                $('#bi-monthly-select').attr('data-interval-frequency', 2);
                selectBottleNumber = 1;
            }
        }
console.log(spId, '<<<<<<<abhiagsgs biiii')
        $('#bi-monthly-select').attr('data-renewal-duration', selectedMonthFrequency * selectBottleNumber).attr('spid',spId);
    });

    // $( ".select-bottle-item" ).click(function() {
    //     //Selected month
    //     selectedMonthFrequency = $(this).attr('data-shipping-frequency');
    //     console.log('Selected month frequency', selectedMonthFrequency);

    //     if (selectedMonthFrequency == 3) {

    //         ƒ = findMatchedProduct(ProductObj.productTitle, threeMonthProducts);

    //         matchedVariant = findMatchedVariant(ProductObj.productVariantTitle, matchedProduct.variants);
    //         // console.log(matchedVariant);

    //         // three months prepaid subscription
    //         selectedMonthsQuantity = 1;
    //         console.log(selectedMonthsQuantity);
    //         console.log(selectedMonthFrequency);
    //         subscriptionId = 225162;

    //         //free gift for subscrition 3/6/12 months
    //         // additionalSubscriptionProductId = 31421434953818;
    //         // additionalSubscriptionProductQuantity = 1;

    //     } else if (selectedMonthFrequency == 6) {

    //         matchedProduct = findMatchedProduct(ProductObj.productTitle, sixMonthProducts);

    //         matchedVariant = findMatchedVariant(ProductObj.productVariantTitle, matchedProduct.variants);
    //         // console.log(matchedVariant);

    //         // three months prepaid subscription
    //         selectedMonthsQuantity = 1;
    //         console.log(selectedMonthsQuantity);
    //         console.log(selectedMonthFrequency);
    //         subscriptionId = 225187;

    //         //free gift for subscrition 3/6/12 months
    //         // additionalSubscriptionProductId = 31421468246106;
    //         // additionalSubscriptionProductQuantity = 1;

    //     } else if (selectedMonthFrequency == 12) {
    //         matchedProduct = findMatchedProduct(ProductObj.productTitle, twelveMonthProducts);

    //         matchedVariant = findMatchedVariant(ProductObj.productVariantTitle, matchedProduct.variants);
    //         // console.log(matchedVariant);

    //         // three months prepaid subscription
    //         selectedMonthsQuantity = 1;
    //         console.log(selectedMonthsQuantity);
    //         console.log(selectedMonthFrequency);
    //         subscriptionId = 225192;

    //         //free gift for subscrition 3/6/12 months
    //         // additionalSubscriptionProductId = 31421354803290;
    //         // additionalSubscriptionProductQuantity = 1;
    //     }

    //     if ($(".select-bottle-item").hasClass("selected")) {
    //         $(".select-bottle-item").removeClass("selected");
    //     }
    //     if ($(".select-month-item").hasClass("selected")) {
    //         $(".select-month-item").removeClass("selected");
    //     }

    //     $(this).addClass("selected");
    //     stepFour();
    // });

    //Gift textbox expand
    $('.gift-woo').on('click', function() {
        $('.gift-woo').addClass('gift-checked');

        $(this).siblings('.gift-check').attr('checked', true);

        $(this).parent().siblings('.gift-textarea').toggle(function() {
            var $parent = $(this).parents('.select-month-item');
            var $maxHeight = 'select-month_max_height';

            if ($parent.hasClass($maxHeight)) {
                $parent.removeClass($maxHeight);
                $(this).siblings('.gift-input').children('.gift-check').attr('checked', false);

            } else {
                $parent.addClass($maxHeight);
                $(this).siblings('.gift-check').attr('checked', true);
            }
        });
    });

    //save gift message to properties
    $('.gift-textarea').on('change', function(ele) {
        var $select = $(this).parents('.select-month-item').find('.select-month-item_btn');

        $select.attr('data-gift-message', $(this).children().val());
    });

    function stepFour() {
        if ($(".select-month-item").hasClass("selected")) {
            $(".checkout-step-three").fadeOut(100);
            $(".checkout-step-four").fadeIn(1000);

            $(".step-three-button").addClass("pointer");
            $(".step-button-wrapper.step-three-button").children('.step-item').addClass("active-btn");
            $(".step-button-wrapper.step-four-button").children('.step-item').addClass("active-btn");

            if (width <= 768) {
                $(".step-one-button .step-title").css('display', 'none');
                $(".step-two-button .step-title").css('display', 'none');
                $(".step-three-button .step-title").css('display', 'none');
                $(".step-four-button .step-title").css('display', 'flex');
            }
            // rechargeAddToCart();
        }
        if ($(".select-bottle-item").hasClass("selected")) {
            $(".checkout-step-three").fadeOut(100);
            $(".checkout-step-four").fadeIn(1000);

            $(".step-three-button").addClass("pointer");
            $(".step-button-wrapper.step-three-button").children('.step-item').addClass("active-btn");
            $(".step-button-wrapper.step-four-button").children('.step-item').addClass("active-btn");

            if (width <= 768) {
                $(".step-one-button .step-title").css('display', 'none');
                $(".step-two-button .step-title").css('display', 'none');
                $(".step-three-button .step-title").css('display', 'none');
                $(".step-four-button .step-title").css('display', 'flex');
            }
            // rechargeAddToCart();
        }

        $(window).scrollTop(0);

    }


    //Might not need this function
    // function rechargeAddToCart(){
    //     // console.log('test', variantId, selectedMonthsQuantity, selectedMonthFrequency, "Months", subscriptionId);
    //     console.log('data',variantId, selectedMonthsQuantity, selectedMonthFrequency, "Months", subscriptionId);

    //     addItemToCart(variantId, selectedMonthsQuantity, selectedMonthFrequency, "Months", subscriptionId);

    // };

    function addItemToCart(variant_id, quantity, charge_interval_frequency, shipping_interval_unit_type, subscription_id, gift_message, isGiftChecked, spid) {
        var data = {};

        
        // if(isGiftChecked){
        //     data = {
        //         "id": variant_id,
        //         "quantity": 1,
        //         "properties[shipping_interval_frequency]": parseInt(quantity), //1,2 shipping
        //         "properties[shipping_interval_unit_type]": shipping_interval_unit_type, //months
        //         "properties[subscription_id]": subscription_id,
        //         "properties[shipping_quantity]": charge_interval_frequency / quantity,
        //         "properties[charge_interval_frequency]": parseInt(charge_interval_frequency), //3,6,12 charge
        //         "properties[gift_message]": gift_message,
        //         "properties[number_charges_until_expiration]": 1
        //     }; 
        // }else{
        //     data = {
        //         "id": variant_id,
        //         "quantity": 1,
        //         "properties[shipping_interval_frequency]": parseInt(quantity), //1,2 shipping
        //         "properties[shipping_interval_unit_type]": shipping_interval_unit_type, //months
        //         "properties[subscription_id]": subscription_id,
        //         "properties[shipping_quantity]": charge_interval_frequency / quantity,
        //         "properties[charge_interval_frequency]": parseInt(charge_interval_frequency), //3,6,12 charge
        //         "properties[gift_message]": gift_message
        //     };
        // }


          if(isGiftChecked){
            data = {
                "id": variant_id,
                "quantity": 1,
              "selling_plan": spid,
                "properties[gift_message]": gift_message,
              
            }; 
        }else{
            data = {
                "id": variant_id,
                "quantity": 1,
              "selling_plan": spid
            };
        }
      console.log(data, '<<<<<<dataa')

        jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function(response) {
                console.log("succes added to cart");
                console.log(response)
                $.ajax({
                  url: '/cart.js',
                  dataType: 'json',
                  cache: false,
                  success(cart) {
                    console.log(cart,'<<<')
                    setTimeout(function () {
                      refreshCart(cart);
                      if ($('body').hasClass('fancybox-active')) {
                        $.fancybox.close();
                      }
      
                      if ($('#header').is(':visible')) {
                        $('#header .cart-container').addClass('active_link');
                      } else if ($('.sticky_nav--stick').length) {
                        $('.sticky_nav .cart-container').addClass('active_link');
                      } else {
                        $('.top-bar .cart-container').addClass('active_link');
                      }
      
                      // block scrolling on mobile
                      if (window.Shopify.media_queries.medium.matches) {
                        const $cartContainer = $(this).parent();
                        if ($cartContainer.hasClass('active_link')) {
                          $('body').addClass('blocked-scroll');
                        } else {
                          $('body').addClass('blocked-scroll');
                        }
                      }
                    }, 500);
                  },
                });

                stepFour();

                //var updates = {};
                //updates[additionalSubscriptionProductId] = additionalSubscriptionProductQuantity;
                //jQuery.post('/cart/update.js', {
                //    updates: updates
                //}, function(response){
                //    Shopify.onItemAdded(response);
                //});
            }
        });
        //window.location = '/checkout';
        // stepFour();
    }

    // Search same product in collection
    function findMatchedProduct(selectedTitle, products) {
        var product = {};
        products.forEach(function(p) {
            var title = p.title.match(/([^\d+]+)/)[0].trim();
            if (title == selectedTitle) product = p;
        });
        return product;
    }
    // Search same variant in collection
    function findMatchedVariant(selectedVariantTitle, variants) {
        var variant = {};
        variants.forEach(function(v) {

            if (v.title == selectedVariantTitle) {
                variant['variant_id'] = v.id;
                variant['variant_price'] = v.price;
                variant['selling_plan_id'] = v.selling_plan_allocations[0].selling_plan_id;
            }
        });
        return variant;
    }

    // step four
    $(".step-three-button .step-item").on('click touchstart', function() {
        stepThree();
        $(window).scrollTop(0);
    });

    function stepThree() {
        if ($(".step-three-button").children('.step-item').hasClass("active-btn")) {
            $(".step-button-wrapper.step-four-button").children('.step-item').removeClass("active-btn");
            $(".checkout-step-one").fadeOut(100);
            $(".checkout-step-two").fadeOut(100);
            $(".checkout-step-four").fadeOut(100);
            $(".checkout-step-three").fadeIn(1000);
            $(".step-two-button").addClass("pointer");
            $(".step-three-button").removeClass("pointer");
        }

        if (width <= 768) {
            $(".step-one-button .step-title").css('display', 'none');
            $(".step-two-button .step-title").css('display', 'none');
            $(".step-three-button .step-title").css('display', 'flex');
            $(".step-four-button .step-title").css('display', 'none');
        }

        $(".step-button-wrapper.step-three-button").children('.step-one_selected').remove();

        $('.step-one-button, .step-one-line').addClass('step-hide');
        $('.step-four-button, .step-line-adjust').addClass('step-show-mobile');
        $('.step-title-desktop').addClass('step-title-hide');

        $('.arrow').attr('data-prev', 2);

        $('.gift-check').each(function() {
          console.log('last here')
            $(this).attr('checked', false);
        });

        $('.gift-textarea').each(function() {
            $(this).hide();
            $(this).children().val('');

            $(this).parents('.select-month-item').removeClass('select-month_max_height');
        });
    }

    $("#recharge_checkout").on('click touchstart', function() {
        /*function get_cookie(name) { return (document.cookie.match('(^|; )' + name + '=([^;]*)') || 0)[2] }
        do {
            token = get_cookie('cart');
        }
        while (token == undefined);
        var myshopify_domain = $('#shop_domain').val();

        try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch (err) { var ga_linker = '' }
        checkout_url =
            "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=" + myshopify_domain + "&cart_token=" + token + "&" + ga_linker;
        window.location.href = checkout_url; */
    });

    function convertPrice(price) {
        return (price / 100).toFixed(2)
    }
    // checkout steps js then takes over, finds correct buttons, and triggers them
  const holidayVId = window.location.search.match(/(variant=)([0-9]+)/g)?.[0]?.replace('variant=','');
  const holidayPId = window.location.search.match(/(product=)([0-9]+)/g)?.[0]?.replace('product=','');
  if(holidayPId && holidayVId){
    console.log('here in this');
    document.querySelector(`a.checkout-product-item[data-product-id="${holidayPId}"]`).click();
    document.querySelector(`a.club-level-item_btn[data-product-variant-id="${holidayVId}"]`).click();
  }
});